import { render, staticRenderFns } from "./OrderNote.vue?vue&type=template&id=1d4fea2e"
import script from "./OrderNote.vue?vue&type=script&lang=js"
export * from "./OrderNote.vue?vue&type=script&lang=js"
import style0 from "./OrderNote.vue?vue&type=style&index=0&id=1d4fea2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports